export class MedicineDuration {
  displayClass: string;
  time: string;
}
